import AppleButton from "./AppleButton";

/**
 * @namespace Elements.Elements/AppleButton
 */

export {AppleButton};
export default AppleButton;
